function toSingular(string) {
  return string.slice(0, -1) // remove trailing s
}

export default toSingular
